<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 提现审批
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- Tab 切换 -->
          <div class="toolbar">
            <el-radio-group v-model="activeTab" @change="handleTabChange">
              <el-radio-button label="pending">待审批</el-radio-button>
              <el-radio-button label="all">全部记录</el-radio-button>
            </el-radio-group>
          </div>

          <!-- 提现表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
              <el-table-column align="center" label="申请人" width="120">
                <template #default="{ row }">
                  <div>{{ row.memberName || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">{{ row.memberPhone }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="角色" width="100">
                <template #default="{ row }">
                  <el-tag :type="roleTagType(row.memberRole)" size="small">{{ row.memberRoleName || '-' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="提现金额" width="120">
                <template #default="{ row }">
                  <span style="color: #e6a23c; font-weight: bold;">¥{{ formatPrice(row.amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="100">
                <template #default="{ row }">
                  <el-tag :type="withdrawalStatusType(row.status)" size="small">{{ row.statusName }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="驳回原因" prop="rejectReason" min-width="140" show-overflow-tooltip>
                <template #default="{ row }">{{ row.rejectReason || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="申请时间" width="160">
                <template #default="{ row }">{{ row.createTime || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="审批时间" width="160">
                <template #default="{ row }">{{ row.approveTime || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="140" v-if="activeTab === 'pending'">
                <template #default="{ row }">
                  <span class="editor" @click="handleApprove(row)">通过</span>
                  <span class="del" @click="handleReject(row)">驳回</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 驳回原因弹窗 -->
    <el-dialog title="驳回提现" v-model="rejectDialogVisible" width="400px" center>
      <el-form label-width="80px">
        <el-form-item label="驳回原因">
          <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmReject" :loading="rejecting">确定驳回</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      activeTab: 'pending',
      // 驳回
      rejectDialogVisible: false,
      rejectReason: '',
      rejectingId: null,
      rejecting: false,
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    roleTagType(role) {
      const map = { 1: 'danger', 2: 'warning', 3: '', 4: 'info' }
      return map[role] || 'info'
    },
    withdrawalStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' }
      return map[status] || 'info'
    },
    handleTabChange() {
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const url = this.activeTab === 'pending'
          ? '/mall/admin/withdrawal/pending'
          : '/mall/admin/withdrawal/list'
        const res = await axiosconf.applicationJson(url)
        if (res.data && res.data.code === 0) {
          const data = res.data.data
          this.tableData = data.records || data || []
        }
      } catch (e) {
        console.error('获取提现列表失败', e)
      } finally {
        this.loading = false
      }
    },
    async handleApprove(row) {
      try {
        await this.$confirm(`确定通过该笔 ¥${this.formatPrice(row.amount)} 的提现申请？`, '提示', { type: 'warning' })
        const res = await axiosconf.applicationJson(`/mall/admin/withdrawal/approve/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.$message.success('审批通过')
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        // 用户取消
      }
    },
    handleReject(row) {
      this.rejectingId = row.id
      this.rejectReason = ''
      this.rejectDialogVisible = true
    },
    async confirmReject() {
      if (!this.rejectReason.trim()) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.rejecting = true
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/withdrawal/reject/${this.rejectingId}`, {
          reason: this.rejectReason
        })
        if (res.data && res.data.code === 0) {
          this.$message.success('已驳回')
          this.rejectDialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.rejecting = false
      }
    },
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
}
.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 10px;
}
.del {
  color: #f56c6c;
  cursor: pointer;
}
</style>
